(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const slideshow = document.querySelector('.custom-slideshow');
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('.slide');
    const navigationButtons = slideshow.querySelectorAll('.slideshow-navigation button');
    let currentIndex = 0;
    let intervalId;
    const intervalTime = 5000; // Cambia de slide cada 5 segundos

    function showSlide(index) {
      slides.forEach(slide => slide.classList.remove('active'));
      navigationButtons.forEach(button => button.classList.remove('active'));

      slides[index].classList.add('active');
      navigationButtons[index].classList.add('active');
      currentIndex = index;
      adjustSlideshowHeight(); // Ajustar altura al mostrar el slide
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startAutoplay() {
      intervalId = setInterval(nextSlide, intervalTime);
    }

    function stopAutoplay() {
      clearInterval(intervalId);
    }

    function adjustSlideshowHeight() {
      const activeSlide = slides[currentIndex];
      if (activeSlide && activeSlide.style.backgroundImage) {
        const img = new Image();
        img.onload = function() {
          const aspectRatio = this.width / this.height;
          const containerWidth = slideshow.offsetWidth;
          slideshow.style.minHeight = `${containerWidth / aspectRatio}px`;
        };
        const url = activeSlide.style.backgroundImage.slice(4, -1).replace(/"/g, "");
        img.src = url;
      } else {
        slideshow.style.minHeight = '200px'; // Altura mínima por defecto
      }
    }

    if (navigationButtons.length > 0) {
      navigationButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          stopAutoplay();
          showSlide(index);
          startAutoplay(); // Reinicia el autoplay después de la navegación manual
        });
      });
    }

    // Initial adjustment and start autoplay
    adjustSlideshowHeight();
    if (slides.length > 1) {
      showSlide(0);
      startAutoplay();
    } else if (slides.length === 1) {
      slides[0].classList.add('active');
    }

    // Re-adjust height on window resize
    window.addEventListener('resize', adjustSlideshowHeight);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
